import * as React from 'react';
import { Navbar } from 'react-bootstrap';
import { useAppContext } from 'providers/AppProvider';
import classNames from 'classnames';
import NavbarBrand from 'components/navbars/nav-items/NavbarBrand';
import NavItems from 'components/navbars/nav-items/NavItems';
import NavItemsSlim from 'components/navbars/nav-items/NavItemsSlim';
import { Row, Col } from 'react-bootstrap';
import { useMainLayoutContext } from 'providers/MainLayoutProvider';

interface NavbarTopDefaultProps {
  children?: React.ReactNode;
}

const NavbarTopDefault: React.FC<NavbarTopDefaultProps> = ({ children }) => {
  const {
    config: { navbarTopShape, navbarTopAppearance }
  } = useAppContext();
  const { avatarInitials } = useMainLayoutContext();

  return (
    <Navbar
      className={classNames('navbar-top fixed-top', {
        'navbar-slim': navbarTopShape === 'slim'
      })}
      expand
      variant=""
      data-navbar-appearance={navbarTopAppearance === 'darker' ? 'darker' : ''}
    >
      <div className="navbar-collapse justify-content-between">
        <Row>
          <Col>
            <NavbarBrand />
          </Col>
          <Col>{children}</Col>
        </Row>

        {navbarTopShape === 'default' ? (
          <>
            <NavItems initials={avatarInitials} />
          </>
        ) : (
          <NavItemsSlim />
        )}
      </div>
    </Navbar>
  );
};

export default NavbarTopDefault;
